import { Component, Input, OnInit } from '@angular/core';

/** @format */
import { AnalyticsService } from '@shared/utils/services';
import { Chain } from '@shared/data-access/interfaces';
import { MarketingService } from '../../service/marketing.service';
import { sha256 } from 'js-sha256';

@Component({
    selector: 'engage-email-signup',
    templateUrl: './email-signup.component.html',
    styleUrls: ['./email-signup.component.scss'],
    standalone: false
})
export class EmailSignupComponent implements OnInit {
	@Input()
	chainAbbr: string;

	public chainIdentifier: string = this.chain.chainIdentifierAbbr;

	/**
	 * @type object
	 *
	 * @description
	 * this is where each chain's percentages are stored for email signup.
	 */
	public PERCENTDEFAULTS = {
		calia: { default: '20' },
		dsg: { default: '10' },
		g3: { default: '10' },
		gg: { default: '15' },
		pl: { default: '10' }
	};

	/**
	 * @type string
	 *
	 * @description
	 * Response from homR if percentOff attributeType is used.
	 */
	@Input()
	data: any;

	/**
	 * @type string
	 *
	 * @description
	 * percentOff is the string chosen as one of the attributeOptions in homR response.
	 */
	public percentOff: string;

	/**
	 * @type string
	 *
	 * @description
	 *
	 */
	public emailSuccess: string;

	/**
	 * @type {String}
	 *
	 * @description
	 * the email address entered by user
	 */
	public emailAddress: string;

	/**
	 * @type {Boolean}
	 *
	 * @description
	 * Boolean to check if Email Form is submitted , defaulted to false
	 */
	public submitted = false;

	/**
	 * @type string
	 *
	 * @description
	 * Object for displaying message to user based on API response
	 */
	public formInformationMsg = {
		emailAvailability: false,
		available: false,
		subscribe: false,
		resubscribe: false,
		errorMsg: '',
		emailEmptyErrorMsg: false
	};

	constructor(
		private chain: Chain,
		private marketingService: MarketingService,
		private analyticsService: AnalyticsService
	) {}

	ngOnInit(): void {
		this.getEmailSignupSuccessMessageStart();
	}

	/**
	 * @description
	 * funtion to check if email is already registered for loyalty
	 */
	public signUp(form) {
		this.submitted = true;
		if (this.emailAddress === undefined || this.emailAddress === '') {
			this.formInformationMsg.emailEmptyErrorMsg = true;
		} else if (form.valid) {
			this.marketingService.registerEmailAddressForLoyalty$(this.emailAddress, 1).subscribe(
				(status: any) => {
					const hashedEmail = sha256(this.emailAddress).toUpperCase();
					// Display success message
					if (status === 200) {
						this.formInformationMsg.resubscribe = true;
						this.analyticsService.triggerEmailFormSubmit(
							`Welcome back! You've already received this offer. You have been resubscribed to receive other offers.`,
							hashedEmail
						);
					} else {
						this.formInformationMsg.subscribe = true;
						this.analyticsService.triggerEmailFormSubmit(
							'Success! Thank you for signing up.',
							hashedEmail
						);
					}
					this.formInformationMsg.available = true;
					this.formInformationMsg.emailAvailability = false;
					this.submitted = false;
				},
				(err) => {
					if (err && err.error && err.error.user_message) {
						// Display failure message
						this.setErrorMessage(err.error.user_message);
					}
					form.reset();
					this.submitted = false;
				}
			);
		} else {
			this.formInformationMsg.emailAvailability = false;
			this.formInformationMsg.available = false;
			this.formInformationMsg.resubscribe = false;
			this.formInformationMsg.subscribe = false;
			this.analyticsService.triggerEmailFormSubmit(
				'Please enter an email in the format username@domain.com'
			);
		}
	}

	/**
	 * @description
	 * funtion to handle the error scenario
	 */
	public setErrorMessage(message) {
		this.formInformationMsg.emailAvailability = true;
		this.formInformationMsg.subscribe = false;
		this.formInformationMsg.resubscribe = false;
		this.formInformationMsg.errorMsg = message;
		this.analyticsService.triggerEmailFormSubmit(message);
	}

	/**
	 * @description
	 * function to get Email Signup Success text out of chain vars and homR response.
	 */
	public getEmailSignupSuccessMessageStart() {
		try {
			const defaultPercent = this.PERCENTDEFAULTS[this.chain.chainIdentifierAbbr].default
				? this.PERCENTDEFAULTS[this.chain.chainIdentifierAbbr].default
				: '';
			const story = this.data;
			this.percentOff = story.emailSignUp[0].percentOff
				? story.emailSignUp[0].percentOff
				: defaultPercent
				? defaultPercent
				: '';
			if (Number(this.percentOff) !== 0) {
				this.emailSuccess = `Your ${this.percentOff}% off email for ${this.chain.chainName} is on its way to `;
			} else {
				this.emailSuccess = `You have been signed up for ${this.chain.chainName} marketing/promotions. A confirmation email is on its way to `;
			}
		} catch (error) {
			console.error('Issue with content', error);
		}
	}

	/**
	 * @description
	 * function to get styles for display of email signup form elements.
	 */
	public returnStylesForEmailSignUp(textColor: string) {
		let cssString = '';
		cssString = textColor === 'light' ? 'light-text' : textColor === 'dark' ? 'dark-text' : '';
		return cssString;
	}
}
